import type { MembershipData } from '@/data/types';

interface MembershipDuesProps {
  dues: MembershipData['dues'];
}

export function MembershipDues({ dues }: MembershipDuesProps) {
  return (
    <div className="card-professional">
      <h2 className="text-2xl sm:text-3xl font-display font-semibold text-primary-700 mb-6">Dues</h2>

      <div className="space-y-6">
        <p className="text-foreground/80 leading-relaxed">
          {dues.overview}
        </p>

        <div className="card-professional bg-red-50 border-l-4 border-l-red-500">
          <p className="text-red-800 font-semibold leading-relaxed">
            {dues.warning}
          </p>
        </div>

        <div className="space-y-4">
          <p className="text-foreground/80 leading-relaxed">
            {dues.seasonalRules.septemberToNovember}
          </p>
          <p className="text-foreground/80 leading-relaxed">
            {dues.seasonalRules.december}
          </p>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full border border-neutral-300 bg-white rounded-lg shadow-sm">
            <caption className="text-lg font-display font-semibold text-primary-700 mb-4">
              Dues Structure
            </caption>
            <thead>
              <tr className="bg-primary/5">
                <th className="border border-neutral-300 px-4 py-3 text-left font-semibold text-primary-700">
                  Membership Type
                </th>
                <th className="border border-neutral-300 px-4 py-3 text-left font-semibold text-primary-700">
                  Annual Fee
                </th>
                <th className="border border-neutral-300 px-4 py-3 text-left font-semibold text-primary-700">
                  Comments
                </th>
                <th className="border border-neutral-300 px-4 py-3 text-center font-semibold text-primary-700">
                  Join in September & October
                </th>
                <th className="border border-neutral-300 px-4 py-3 text-left font-semibold text-primary-700">
                  Join in November & December
                </th>
              </tr>
            </thead>
            <tbody>
              {dues.structure.map((membership, index) => (
                <tr key={index} className="hover:bg-primary/5">
                  <td className="border border-neutral-300 px-4 py-3 text-foreground/80">
                    {membership.type}
                  </td>
                  <td className="border border-neutral-300 px-4 py-3 text-foreground/80">
                    ${membership.annualFee}
                  </td>
                  <td className="border border-neutral-300 px-4 py-3 text-foreground/80">
                    {membership.comments && (
                      <div className="space-y-2">
                        {membership.comments.split('. ').map((sentence, idx) => (
                          <p key={idx} className="text-sm">
                            {sentence}{idx < membership.comments.split('. ').length - 1 ? '.' : ''}
                          </p>
                        ))}
                      </div>
                    )}
                  </td>
                  <td className="border border-neutral-300 px-4 py-3 text-center text-foreground/80">
                    {membership.septemberOctober ? `$${membership.septemberOctober}` : ''}
                  </td>
                  <td className="border border-neutral-300 px-4 py-3 text-foreground/80">
                    {membership.novemberDecember === 'prepays for the next year'
                      ? `$${membership.annualFee}, but prepays for the next year`
                      : membership.novemberDecember || ''}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}